import ListingApplicationsTab from './ListingApplicationsTab';

export default ListingApplicationsTab;
